import { g as gsapWithCSS } from "@theme/theme";
class CtaProductComponent extends window.HTMLElement {
  constructor() {
    super();
    this.DOM = {
      groupBtns: this.querySelectorAll(".js-group-button"),
      groupItems: this.querySelectorAll(".js-group-item")
    };
    this.delayedCall = null;
  }
  connectedCallback() {
    this.bindEvents();
  }
  bindEvents() {
    this.DOM.groupBtns.forEach((btn) => {
      btn.addEventListener("click", this.groupBtnClick.bind(this));
    });
  }
  groupBtnClick(e) {
    const currentBtn = e.currentTarget;
    const index = currentBtn.getAttribute("data-index");
    const currentItem = this.DOM.groupItems[index];
    if (currentBtn.classList.contains("is-active") || !currentItem) return;
    const activeBtn = this.querySelector(".js-group-button.is-active");
    const activeItem = this.querySelector(".js-group-item.is-active");
    activeBtn.classList.remove("is-active");
    currentBtn.classList.add("is-active");
    activeItem.classList.remove("is-active");
    if (this.delayedCall) this.delayedCall.kill();
    this.delayedCall = gsapWithCSS.delayedCall(1, () => {
      currentItem.classList.add("is-active");
    });
  }
}
window.customElements.define("c-cta-product", CtaProductComponent);
